import * as BIBCONFIG from '../../constants/bibConfig';

import BIB_ORGANIZER_LOGO_PATH from '../../assets/bib_organizer.png';
import BIB_ORGANIZER_SPONSOR_PATH from '../../assets/groupe_crc.png';
import BIB_ORGANIZER_SPONSOR2_PATH from '../../assets/canal_box.png';
import BIB_ORGANIZER_SPONSOR3_PATH from '../../assets/region_reunion.png';
import BIB_ORGANIZER_SPONSOR4_PATH from '../../assets/ca.png';

class Drawer {
  constructor() {
    this.organizerLogo = null;
    this.sponsorLogo = null;
    this.sponsorLogo2 = null;
    this.sponsorLogo3 = null;
    this.sponsorLogo4 = null;

    this.name = null;
    this.companyName = null;
    this.bibNumber = null;
  }

  drawImage(ctx, image, path, posX, posY, width, height) {
    if (image === null) {
      image = new Image();

      image.src = path;
      image.onload = () => {
        ctx.drawImage(image,
          posX,
          posY,
          width,
          height);
      };
    }

    ctx.drawImage(image,
      posX,
      posY,
      width,
      height);
  }

  drawBackground(ctx) {
    ctx.beginPath();
    ctx.rect(0, 0, BIBCONFIG.WIDTH, BIBCONFIG.HEIGHT);
    ctx.fillStyle = BIBCONFIG.FILL_COLOR;
    ctx.fill();

    ctx.beginPath();
    ctx.fillStyle = BIBCONFIG.BG_COLOR;
    ctx.fillRect(0, 0, BIBCONFIG.WIDTH, 500);
    ctx.fillRect(0, 1600, BIBCONFIG.WIDTH, 500);
    ctx.fill();

    ctx.beginPath();
    ctx.fillStyle = BIBCONFIG.FILL_COLOR;
    ctx.arc(100, 100, 40, 0, 2 * Math.PI, false);
    ctx.fill();

    ctx.beginPath();
    ctx.fillStyle = BIBCONFIG.FILL_COLOR;
    ctx.arc(BIBCONFIG.WIDTH - 100, 100, 40, 0, 2 * Math.PI, false);
    ctx.fill();

    ctx.beginPath();
    ctx.fillStyle = BIBCONFIG.FILL_COLOR;
    ctx.arc(100, BIBCONFIG.HEIGHT - 100, 40, 0, 2 * Math.PI, false);
    ctx.fill();

    ctx.beginPath();
    ctx.fillStyle = BIBCONFIG.FILL_COLOR;
    ctx.arc(BIBCONFIG.WIDTH - 100, BIBCONFIG.HEIGHT - 100, 40, 0, 2 * Math.PI, false);
    ctx.fill();
  }

  drawHeader(ctx) {
    const fontSize = 70;

    ctx.beginPath();
    ctx.fillStyle = BIBCONFIG.TITLE_COLOR;
    ctx.font = `${fontSize}pt Frutiger-bold`;
    // syntax : .fillText("text", x, y)
    ctx.textAlign = 'center';

    ctx.fillText(BIBCONFIG.TITLE, BIBCONFIG.WIDTH / 2, 445);
    ctx.fill();

    this.drawOrganizerLogo(ctx);
  }

  drawOrganizerLogo(ctx) {
    this.drawImage(ctx,
      this.organizerLogo,
      BIB_ORGANIZER_LOGO_PATH,
      BIBCONFIG.BIB_ORGANIZER_POS_X,
      BIBCONFIG.BIB_ORGANIZER_POS_Y,
      BIBCONFIG.BIB_ORGANIZER_LOGO_WIDTH,
      BIBCONFIG.BIB_ORGANIZER_LOGO_HEIGHT);
  }

  drawFooter(ctx) {
    this.drawImage(ctx,
      this.sponsorLogo,
      BIB_ORGANIZER_SPONSOR_PATH,
      BIBCONFIG.BIB_SPONSOR_POS_X,
      BIBCONFIG.BIB_SPONSOR_POS_Y,
      BIBCONFIG.BIB_SPONSOR_LOGO_WIDTH,
      BIBCONFIG.BIB_SPONSOR_LOGO_HEIGHT);

    this.drawImage(ctx,
      this.sponsorLogo2,
      BIB_ORGANIZER_SPONSOR2_PATH,
      BIBCONFIG.BIB_SPONSOR2_POS_X,
      BIBCONFIG.BIB_SPONSOR2_POS_Y,
      BIBCONFIG.BIB_SPONSOR2_LOGO_WIDTH,
      BIBCONFIG.BIB_SPONSOR2_LOGO_HEIGHT);

    this.drawImage(ctx,
      this.sponsorLogo3,
      BIB_ORGANIZER_SPONSOR3_PATH,
      BIBCONFIG.BIB_SPONSOR3_POS_X,
      BIBCONFIG.BIB_SPONSOR3_POS_Y,
      BIBCONFIG.BIB_SPONSOR3_LOGO_WIDTH,
      BIBCONFIG.BIB_SPONSOR3_LOGO_HEIGHT);

    this.drawImage(ctx,
      this.sponsorLogo4,
      BIB_ORGANIZER_SPONSOR4_PATH,
      BIBCONFIG.BIB_SPONSOR4_POS_X,
      BIBCONFIG.BIB_SPONSOR4_POS_Y,
      BIBCONFIG.BIB_SPONSOR4_LOGO_WIDTH,
      BIBCONFIG.BIB_SPONSOR4_LOGO_HEIGHT);
  }

  drawBibNumber(ctx, bibNumber) {
    const fontSize = 375;
    this.bibNumber = bibNumber;

    ctx.beginPath();
    ctx.fillStyle = BIBCONFIG.BIB_NUMBER_COLOR;
    ctx.font = `${fontSize}pt Frutiger-bold`;
    ctx.textAlign = 'center';

    if (this.companyName === null) {
      ctx.fillText(bibNumber, BIBCONFIG.WIDTH / 2, BIBCONFIG.HEIGHT / 2 + 150);
    } else {
      ctx.fillText(bibNumber, BIBCONFIG.WIDTH / 2, BIBCONFIG.HEIGHT / 2);
    }
    ctx.fill();
  }

  drawCompanyName(ctx, companyName) {
    const fontSize = 125;
    this.companyName = companyName;

    ctx.beginPath();
    ctx.fillStyle = BIBCONFIG.COMPANY_COLOR;
    ctx.font = `${fontSize}pt Frutiger-bold`;
    ctx.textAlign = 'center';
    ctx.fillText(companyName, BIBCONFIG.WIDTH / 2, BIBCONFIG.HEIGHT / 2 + 325);
    ctx.fill();
  }

  drawName(ctx, name) {
    const fontSize = 70;
    this.name = name;

    ctx.beginPath();
    ctx.fillStyle = BIBCONFIG.NAME_COLOR;
    ctx.font = `${fontSize}pt Frutiger-roman`;
    ctx.textAlign = 'center';
    ctx.fillText(name, BIBCONFIG.WIDTH / 2, BIBCONFIG.HEIGHT / 2 + 450);
    ctx.fill();
  }
}

export default Drawer;
